module.exports = __webpack_public_path__ + "files/7aef702f9444b08b07ab8825f1aa5745.png";